// // import React from 'react';
// // import CountUp from 'react-countup';
// // import icon1 from '../../icons/icon_dollar.svg';
// // import icon2 from '../../icons/icon_chart.svg';
// // import icon3 from '../../icons/icon_gift.svg';
// // import shape1 from '../../images/shapes/shape_chart.svg';
// // import shape2 from '../../images/shapes/shape_range.svg';
// // import shape3 from '../../images/shapes/shape_poligon.svg';

// // const features = [
// //     {
// //         icon: icon1,
// //         title: 'Expected Investment Value',
// //         description: '180,000 $ ROI = 360%',
// //     },
// //     {
// //         icon: icon2,
// //         title: 'Expected Investment Value',
// //         description: '180,000 $ ROI = 360%',
// //     },
// //     {
// //         icon: icon3,
// //         title: 'Expected Investment Value',
// //         description: '180,000 $ ROI = 360%',
// //     },
// // ];

// // const FeaturesSection = () => {
    
// //     return (
// //         <section className="ico_feature_section section_space section_decoration">
// //             <div className="container">
// //                 <div className="row justify-content-lg-between">
// //                     {/* Left Side - Features List */}
// //                     <div className="col-lg-5">
// //                         <div className="ico_heading_block" data-aos="fade-up" data-aos-duration="600">
// //                             <h2 className="heading_text mb-0">Why Panda Sovereign is Worth Buying Today?</h2>
// //                         </div>
// //                         <ul className="ico_features_group unordered_list_block">
// //                             {features.map((feature, index) => (
// //                                 <li key={index} data-aos="fade-up" data-aos-duration="600" data-aos-delay={`${(index + 1) * 100}`}>
// //                                     <div className="ico_iconbox_icon_left">
// //                                         <div className="iconbox_icon">
// //                                             <img src={feature.icon} alt={`Icon ${feature.title}`} />
// //                                         </div>
// //                                         <div className="iconbox_info">
// //                                             <h3 className="iconbox_title">{feature.title}</h3>
// //                                             <p className="iconbox_description mb-0">{feature.description}</p>
// //                                         </div>
// //                                     </div>
// //                                 </li>
// //                             ))}
// //                         </ul>
// //                     </div>

// //                     {/* Right Side - Investment Details */}
// //                     <div className="col-lg-6">
// //                         <ul
// //                             className="ico_investment_value unordered_list justify-content-md-between"
// //                             data-aos="fade-up"
// //                             data-aos-duration="600"
// //                         >
// //                             <li>
// //                                 <h4 className="heading_text">Amount Invested</h4>
// //                                 <div className="investment_value">
// //                                     <span className="odometer" data-count="60000"><CountUp end={60000} enableScrollSpy scrollSpyOnce/></span>
// //                                     <span>$</span>
// //                                 </div>
// //                             </li>
// //                             <li>
// //                                 <h4 className="heading_text">Quantity Panda Sovereign</h4>
// //                                 <div className="investment_value">
// //                                     <span className="odometer" data-count="60000"><CountUp end={6000} enableScrollSpy scrollSpyOnce/></span>
// //                                     <span>Panda Sovereign</span>
// //                                 </div>
// //                             </li>
// //                         </ul>

// //                         {/* Coin Purchase Price */}
// //                         <div className="ico_coin_purchase_price" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
// //                             <p className="purchase_price_rate mb-0 text-secondary">
// //                                 Purchase Price Panda Sovereign <strong>0.166$</strong>
// //                             </p>
// //                             <div className="chart_image">
// //                                 <img src={shape1} alt="Shape Chart" />
// //                             </div>
// //                             <div className="live_values">
// //                                 <span>100$</span>
// //                                 <span>100.000$</span>
// //                             </div>
// //                         </div>

// //                         {/* Calculation Range */}
// //                         <div className="ico_calculation_range" data-aos="fade-up" data-aos-duration="600" data-aos-delay="200">
// //                             <div className="live_values">
// //                                 <span>Calculation Time</span>
// //                                 <span>Q3 2025</span>
// //                             </div>
// //                             <div className="range_image">
// //                                 <img src={shape2} alt="Shape Range" />
// //                             </div>
// //                             <div className="live_values">
// //                                 <span>100$</span>
// //                                 <span>100.000$</span>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Decorations */}
// //             <div className="decoration_item shape_shadow_1">
// //                 <img src={shape3} alt="Shape Color Shadow" />
// //             </div>
// //             <div className="decoration_item shape_shadow_2">
// //                 <img src={shape3} alt="Shape Color Shadow" />
// //             </div>
// //         </section>
// //     );
// // };

// // export default FeaturesSection;

// import CountUp from "react-countup"
// import { useApi } from "../../hooks/useApi"
// import icon1 from "../../icons/icon_dollar.svg"
// import shape1 from "../../images/shapes/shape_chart.svg"
// import shape2 from "../../images/shapes/shape_range.svg"
// import shape3 from "../../images/shapes/shape_poligon.svg"

// const FeaturesSection = () => {
//   const { data: featuresData, loading, error } = useApi("/features")

//   if (loading) {
//     return (
//       <section className="ico_feature_section section_space section_decoration">
//         <div className="container">
//           <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
//             <div className="spinner-border text-primary" role="status">
//               <span className="sr-only">Loading...</span>
//             </div>
//           </div>
//         </div>
//       </section>
//     )
//   }

//   if (error || !featuresData) {
//     return null
//   }

//   return (
//     <section className="ico_feature_section section_space section_decoration">
//       <div className="container">
//         <div className="row justify-content-lg-between">
//           {/* Left Side - Features List */}
//           <div className="col-lg-5">
//             <div className="ico_heading_block" data-aos="fade-up" data-aos-duration="600">
//               <h2 className="heading_text mb-0">{featuresData.title}</h2>
//             </div>
//             <ul className="ico_features_group unordered_list_block">
//               {featuresData.features?.map((feature, index) => (
//                 <li key={index} data-aos="fade-up" data-aos-duration="600" data-aos-delay={`${(index + 1) * 100}`}>
//                   <div className="ico_iconbox_icon_left">
//                     <div className="iconbox_icon">
//                       <img src={feature.icon || icon1} alt={`Icon ${feature.title}`} />
//                     </div>
//                     <div className="iconbox_info">
//                       <h3 className="iconbox_title">{feature.title}</h3>
//                       <p className="iconbox_description mb-0">{feature.description}</p>
//                     </div>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Right Side - Investment Details */}
//           <div className="col-lg-6">
//             <ul
//               className="ico_investment_value unordered_list justify-content-md-between"
//               data-aos="fade-up"
//               data-aos-duration="600"
//             >
//               <li>
//                 <h4 className="heading_text">{featuresData.investment?.amountInvestedLabel}</h4>
//                 <div className="investment_value">
//                   <span className="odometer" data-count={featuresData.investment?.amountInvested}>
//                     <CountUp end={featuresData.investment?.amountInvested || 60000} enableScrollSpy scrollSpyOnce />
//                   </span>
//                   <span>$</span>
//                 </div>
//               </li>
//               <li>
//                 <h4 className="heading_text">{featuresData.investment?.quantityLabel}</h4>
//                 <div className="investment_value">
//                   <span className="odometer" data-count={featuresData.investment?.quantity}>
//                     <CountUp end={featuresData.investment?.quantity || 6000} enableScrollSpy scrollSpyOnce />
//                   </span>
//                   <span>Panda Sovereign</span>
//                 </div>
//               </li>
//             </ul>

//             {/* Coin Purchase Price */}
//             <div className="ico_coin_purchase_price" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
//               <p className="purchase_price_rate mb-0 text-secondary">
//                 {featuresData.purchasePrice?.label} <strong>{featuresData.purchasePrice?.price}</strong>
//               </p>
//               <div className="chart_image">
//                 <img src={shape1 || "/placeholder.svg"} alt="Shape Chart" />
//               </div>
//               <div className="live_values">
//                 <span>{featuresData.purchasePrice?.minValue}</span>
//                 <span>{featuresData.purchasePrice?.maxValue}</span>
//               </div>
//             </div>

//             {/* Calculation Range */}
//             <div className="ico_calculation_range" data-aos="fade-up" data-aos-duration="600" data-aos-delay="200">
//               <div className="live_values">
//                 <span>{featuresData.calculationTime?.label}</span>
//                 <span>{featuresData.calculationTime?.time}</span>
//               </div>
//               <div className="range_image">
//                 <img src={shape2 || "/placeholder.svg"} alt="Shape Range" />
//               </div>
//               <div className="live_values">
//                 <span>{featuresData.calculationTime?.minValue}</span>
//                 <span>{featuresData.calculationTime?.maxValue}</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Decorations */}
//       <div className="decoration_item shape_shadow_1">
//         <img src={shape3 || "/placeholder.svg"} alt="Shape Color Shadow" />
//       </div>
//       <div className="decoration_item shape_shadow_2">
//         <img src={shape3 || "/placeholder.svg"} alt="Shape Color Shadow" />
//       </div>
//     </section>
//   )
// }

// export default FeaturesSection



// *****************************************************************************************************

// import CountUp from "react-countup"
// import { useApi } from "../../hooks/useApi"
// import icon1 from "../../icons/icon_dollar.svg"
// import icon2 from "../../icons/icon_chart.svg"
// import icon3 from "../../icons/icon_gift.svg"
// import shape1 from "../../images/shapes/shape_chart.svg"
// import shape2 from "../../images/shapes/shape_range.svg"
// import shape3 from "../../images/shapes/shape_poligon.svg"

// const FeaturesSection = () => {
//   const { data: featuresData, loading, error } = useApi("/features")

//   // Default fallback data
//   const defaultData = {
//     title: "Why Panda Sovereign is Worth Buying Today?",
//     features: [
//       {
//         icon: icon1,
//         title: "Expected Investment Value",
//         description: "180,000 $ ROI = 360%",
//       },
//       {
//         icon: icon2,
//         title: "Expected Investment Value",
//         description: "180,000 $ ROI = 360%",
//       },
//       {
//         icon: icon3,
//         title: "Expected Investment Value",
//         description: "180,000 $ ROI = 360%",
//       },
//     ],
//     investment: {
//       amountInvestedLabel: "Amount Invested",
//       amountInvested: 60000,
//       quantityLabel: "Quantity Panda Sovereign",
//       quantity: 6000,
//     },
//     purchasePrice: {
//       label: "Purchase Price Panda Sovereign",
//       price: "0.166$",
//       minValue: "100$",
//       maxValue: "100.000$",
//     },
//     calculationTime: {
//       label: "Calculation Time",
//       time: "Q3 2025",
//       minValue: "100$",
//       maxValue: "100.000$",
//     },
//   }

//   // Use API data if available, otherwise use default
//   const displayData = featuresData || defaultData

//   if (loading) {
//     console.log("Features section loading...")
//   }

//   if (error) {
//     console.error("Features API error:", error)
//   }

//   return (
//     <section className="ico_feature_section section_space section_decoration">
//       <div className="container">
//         <div className="row justify-content-lg-between">
//           {/* Left Side - Features List */}
//           <div className="col-lg-5">
//             <div className="ico_heading_block" data-aos="fade-up" data-aos-duration="600">
//               <h2 className="heading_text mb-0">{displayData.heading}</h2>
//             </div>
//             <ul className="ico_features_group unordered_list_block">
//               {displayData.features?.map((feature, index) => (
//                 <li key={index} data-aos="fade-up" data-aos-duration="600" data-aos-delay={`${(index + 1) * 100}`}>
//                   <div className="ico_iconbox_icon_left">
//                     <div className="iconbox_icon">
//                       <img src={feature.icon || "/placeholder.svg"} alt={`Icon ${feature.title}`} />
//                     </div>
//                     <div className="iconbox_info">
//                       <h3 className="iconbox_title">{feature.title}</h3>
//                       <p className="iconbox_description mb-0">{feature.description}</p>
//                     </div>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Right Side - Investment Details */}
//           <div className="col-lg-6">
//             <ul
//               className="ico_investment_value unordered_list justify-content-md-between"
//               data-aos="fade-up"
//               data-aos-duration="600"
//             >
//               <li>
//                 <h4 className="heading_text">{displayData.investment?.amountInvestedLabel}</h4>
//                 <div className="investment_value">
//                   <span className="odometer" data-count={displayData.investment?.amountInvested}>
//                     <CountUp end={displayData.investment?.amountInvested || 60000} enableScrollSpy scrollSpyOnce />
//                   </span>
//                   <span>$</span>
//                 </div>
//               </li>
//               <li>
//                 <h4 className="heading_text">{displayData.investment?.quantityLabel}</h4>
//                 <div className="investment_value">
//                   <span className="odometer" data-count={displayData.investment?.quantity}>
//                     <CountUp end={displayData.investment?.quantity || 6000} enableScrollSpy scrollSpyOnce />
//                   </span>
//                   <span>Panda Sovereign</span>
//                 </div>
//               </li>
//             </ul>

//             {/* Coin Purchase Price */}
//             <div className="ico_coin_purchase_price" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
//               <p className="purchase_price_rate mb-0 text-secondary">
//                 {displayData.purchasePrice?.label} <strong>{displayData.purchasePrice?.price}</strong>
//               </p>
//               <div className="chart_image">
//                 <img src={shape1 || "/placeholder.svg"} alt="Shape Chart" />
//               </div>
//               <div className="live_values">
//                 <span>{displayData.purchasePrice?.minValue}</span>
//                 <span>{displayData.purchasePrice?.maxValue}</span>
//               </div>
//             </div>

//             {/* Calculation Range */}
//             <div className="ico_calculation_range" data-aos="fade-up" data-aos-duration="600" data-aos-delay="200">
//               <div className="live_values">
//                 <span>{displayData.calculationTime?.label}</span>
//                 <span>{displayData.calculationTime?.time}</span>
//               </div>
//               <div className="range_image">
//                 <img src={shape2 || "/placeholder.svg"} alt="Shape Range" />
//               </div>
//               <div className="live_values">
//                 <span>{displayData.calculationTime?.minValue}</span>
//                 <span>{displayData.calculationTime?.maxValue}</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Decorations */}
//       <div className="decoration_item shape_shadow_1">
//         <img src={shape3 || "/placeholder.svg"} alt="Shape Color Shadow" />
//       </div>
//       <div className="decoration_item shape_shadow_2">
//         <img src={shape3 || "/placeholder.svg"} alt="Shape Color Shadow" />
//       </div>
//     </section>
//   )
// }

// export default FeaturesSection






// ********************************************************************
import CountUp from "react-countup"
import { useApi } from "../../hooks/useApi"
import shape1 from "../../images/shapes/shape_chart.svg"
import shape2 from "../../images/shapes/shape_range.svg"
import shape3 from "../../images/shapes/shape_poligon.svg"

const FeaturesSection = () => {
  const { data: featuresData, loading, error } = useApi("/features")

  // Updated fallback data matching the given schema
  const defaultData = {
    _id: "68727992c01d79cc22ceabc5",
    heading: "Why Panda Sovereign is Worth Buying Today?",
    features: [
      {
        icon: "/icons/icon_dollar.svg",
        title: "Expected Investment Value",
        description: "180,000 $ ROI = 360%",
        _id: "68727992c01d79cc22ceabc6",
      },
      {
        icon: "/icons/icon_chart.svg",
        title: "Stable Market Demand",
        description: "Backed by data-driven projections.",
        _id: "68727992c01d79cc22ceabc7",
      },
      {
        icon: "/icons/icon_gift.svg",
        title: "Limited-Time Bonus",
        description: "Extra tokens for early investors.",
        _id: "68727992c01d79cc22ceabc8",
      },
    ],
    investment: {
      amountInvested: 60000,
      quantityPanda: 6000,
    },
    purchasePrice: "0.166$",
    calculationTime: "Q3 2025",
  }

  const displayData = featuresData || defaultData

  if (loading) return <div>Loading...</div>
  if (error) return <div>Error loading features. Please try again later.</div>

  return (
    <section className="ico_feature_section section_space section_decoration">
      <div className="container">
        <div className="row justify-content-lg-between">
          {/* Left Side - Features List */}
          <div className="col-lg-5">
            <div className="ico_heading_block" data-aos="fade-up" data-aos-duration="600">
              <h2 className="heading_text mb-0">{displayData.heading}</h2>
            </div>
            <ul className="ico_features_group unordered_list_block">
              {displayData.features?.map((feature, index) => (
                <li
                  key={feature._id || index}
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay={`${(index + 1) * 100}`}
                >
                  <div className="ico_iconbox_icon_left">
                    <div className="iconbox_icon">
                      <img src={feature.icon || "/placeholder.svg"} alt={`Icon ${feature.title}`} loading="lazy" />
                    </div>
                    <div className="iconbox_info">
                      <h3 className="iconbox_title">{feature.title}</h3>
                      <p className="iconbox_description mb-0">{feature.description}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Side - Investment Details */}
          <div className="col-lg-6">
            <ul
              className="ico_investment_value unordered_list justify-content-md-between"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <li>
                <h4 className="heading_text">Amount Invested</h4>
                <div className="investment_value">
                  <span className="odometer">
                    <CountUp end={displayData.investment?.amountInvested || 0} enableScrollSpy scrollSpyOnce />
                  </span>
                  <span>$</span>
                </div>
              </li>
              <li>
                <h4 className="heading_text">Quantity Panda Sovereign</h4>
                <div className="investment_value">
                  <span className="odometer">
                    <CountUp end={displayData.investment?.quantityPanda || 0} enableScrollSpy scrollSpyOnce />
                  </span>
                  <span>Panda Sovereign</span>
                </div>
              </li>
            </ul>

            {/* Coin Purchase Price */}
            <div className="ico_coin_purchase_price" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
              <p className="purchase_price_rate mb-0 text-secondary">
                Purchase Price Panda Sovereign: <strong>{displayData.investment?.purchasePrice}</strong>
              </p>
              <div className="chart_image">
                <img src={shape1} alt="Shape Chart" />
              </div>
              <div className="live_values">
                          <span>100$</span>
                                <span>100.000$</span>
                         </div>
            </div>

            {/* Calculation Time */}
            <div className="ico_calculation_range" data-aos="fade-up" data-aos-duration="600" data-aos-delay="200">
              <div className="live_values">
                <span>Calculation Time</span>
                <span>{displayData.investment?.calculationTime}</span>
              </div>
              <div className="range_image">
                <img src={shape2} alt="Shape Range" />
              </div>
              <div className="live_values">
                          <span>100$</span>
                                <span>100.000$</span>
                         </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorations */}
      <div className="decoration_item shape_shadow_1">
        <img src={shape3} alt="Shape Color Shadow" />
      </div>
      <div className="decoration_item shape_shadow_2">
        <img src={shape3} alt="Shape Color Shadow" />
      </div>
    </section>
  )
}

export default FeaturesSection
